<template lang="pug">
div
  v-layout(column)
    label: b Soort dienstverband*
    v-select(
      :items='workSituationItems',
      label='Selecteer je dienstverband',
      required,
      v-model='data.workSituation',
      :error-messages='workSituationValidationErrors',
      @change='$v.data.workSituation.$touch()',
      @blur='$v.data.workSituation.$touch()',
      solo
      )

  template(v-if='showSteadyWorkFields || showTempWorkFields')
    text-field.mr-0(
      v-model='data.jobType',
      label='Soort beroep',
      required,
      :error-messages='jobTypeValidationErrors',
      @change='$v.data.jobType.$touch()',
      @blur='$v.data.jobType.$touch()',
      )

    text-field.mr-0(
      v-model='data.companyName',
      label='Bedrijfsnaam',
      required,
      :error-messages='companyNameValidationErrors',
      @change='$v.data.companyName.$touch()',
      @blur='$v.data.companyName.$touch()',
      )

    text-field.mr-0(
      v-model='data.companyCity',
      label='Vestigingsplaats',
      required,
      :error-messages='companyCityValidationErrors',
      @change='$v.data.companyCity.$touch()',
      @blur='$v.data.companyCity.$touch()',
      )

    DatePicker.mr-0(
      label='Begindatum dienstverband'
      v-model='data.dateStarted'
      required,
      propName='dateStarted',
      @setValid='setValid'
      )

    DatePicker.mr-0(
      v-if='showTempWorkFields',
      label='Einddatum dienstverband'
      v-model='data.dateEnded'
      required,
      propName='dateEnded',
      @setValid='setValid'
      )
</template>

<script>
// import { required } from 'vuelidate/lib/validators'
import required from 'vuelidate/src/validators/required'

export default {
  props: {
    value: Object
  },

  data () {
    return {
      workSituationItems: require('./helpers/constants').workSituationItems,

      data: this.value,

      dateStartedValid: false,
      dateEndedValid: false
    }
  },

  methods: {
    setValid ({ propName, valid }) {
      this[propName + 'Valid'] = valid
    }
  },

  computed: {
    showSteadyWorkFields () {
      return (
        this.data.workSituation === 'steady_fulltime' ||
        this.data.workSituation === 'steady_parttime' ||
        this.data.workSituation === 'independent' ||
        this.data.workSituation === 'employmentagency'
      )
    },

    showTempWorkFields () {
      return (
        this.data.workSituation === 'temp_parttime' ||
        this.data.workSituation === 'temp_fulltime'
      )
    },

    workSituationValidationErrors () {
      const errors = []
      if (!this.$v.data.workSituation.$dirty) return errors
      !this.$v.data.workSituation.required && errors.push('Dit veld is verplicht')
      return errors
    },

    jobTypeValidationErrors () {
      const errors = []
      if (!this.$v.data.jobType.$dirty) return errors
      !this.$v.data.jobType.required && errors.push('Dit veld is verplicht')
      return errors
    },

    companyNameValidationErrors () {
      const errors = []
      if (!this.$v.data.companyName.$dirty) return errors
      !this.$v.data.companyName.required && errors.push('Dit veld is verplicht')
      return errors
    },

    companyCityValidationErrors () {
      const errors = []
      if (!this.$v.data.companyCity.$dirty) return errors
      !this.$v.data.companyCity.required && errors.push('Dit veld is verplicht')
      return errors
    }
  },

  validations: {
    data: {
      workSituation: {
        required
      },

      jobType: {
        required: function (v) {
          return (!this.showSteadyWorkFields && !this.showTempWorkFields) || !!v
        }
      },

      companyName: {
        required: function (v) {
          return (!this.showSteadyWorkFields && !this.showTempWorkFields) || !!v
        }
      },

      companyCity: {
        required: function (v) {
          return (!this.showSteadyWorkFields && !this.showTempWorkFields) || !!v
        }
      },

      dateStarted: {
        valid: function (v) {
          return (!this.showSteadyWorkFields && !this.showTempWorkFields) || this.dateStartedValid
        }
      },

      dateEnded: {
        valid: function (v) {
          return (!this.showTempWorkFields) || this.dateEndedValid
        }
      }
    }
  },

  watch: {
    '$v.$invalid': {
      handler: function (invalid) {
        this.$emit('setValid', {
          modelName: 'workModel',
          valid: !invalid
        })
      },
      deep: true,
      immediate: true
    },

    value (v) {
      this.data = v
    },

    data: {
      handler: function (v) {
        this.$emit('input', v)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
